import { useEffect, useState } from 'react';

export type EmailValidation = {
  readonly isValidating: boolean;
  readonly isValid?: boolean;
  readonly message?: string;
};

export type EmailValidationOptions = {
  readonly email: string;
  readonly baseUrl: string;
  readonly hasInitialEmail: boolean;
  readonly isConfluence?: boolean;
};

export function useEmailValidation({
  email,
  hasInitialEmail,
  isConfluence
}: EmailValidationOptions): EmailValidation {
  const [{ isValidating, isValid, message }, setValidation] =
    useState<EmailValidation>({
      isValidating: false
    });

  useEffect(() => {
    if (hasInitialEmail) {
      return setValidation({
        isValidating: false,
        isValid: true,
        message: undefined
      });
    }
    const emailPart = (email || '').split('@');

    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email.length === 0) {
      return setValidation({
        isValidating: false,
        isValid: false,
        message: isConfluence ? 'Please enter a valid email address' : undefined
      });
    } else if (
      !re.test(email) ||
      emailPart[0].length > 64 ||
      emailPart[1].split('.').some((domainPart) => domainPart.length > 63)
    ) {
      return setValidation({
        isValidating: false,
        isValid: false,
        message: 'Please enter a valid email address'
      });
    } else {
      setValidation({
        isValidating: false,
        isValid: true,
        message: undefined
      });
    }
  }, [email]);

  return {
    isValidating,
    isValid,
    message
  };
}
